import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'
import Icon from "../../common/icon/icon.component.jsx"
import Image from "../../common/image/image.component.jsx"

class ProposalColorPreview extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            options: this.props.options || [],
            backgroundImage: null,
            companyLogo: null,
            companyName: '',
            style: this.props.style || {},
            className: this.props.className || '',
            title: this.props.title || '',
            small: this.props.small || false,
        }
    }

    componentDidMount() {
        AppContext.getApiClient().get('/accounts/company-descriptions').then(res => {
            this.setState({
                companyLogo: res.attributes.companyLogo,
                companyName: res.attributes.organization.attributes.name,
            })
        })
        const backgroundImageId = this.getOptionValue("background-image-id")
        if (backgroundImageId) {
            AppContext.getApiClient().get('/images/' + backgroundImageId).then(i => {
                this.setState({
                    backgroundImage: i,
                })
            })
        }

    }

    componentWillReceiveProps(nextProps) {
        let state = {
            options: nextProps.options || [],
            className: nextProps.className || '',
            companyName: nextProps.companyName || '',
            style: nextProps.style || {},
        }
        if (nextProps.companyLogo) {
            state.companyLogo = nextProps.companyLogo
        }
        this.setState(state, () => {
            const backgroundImageId = this.getOptionValue("background-image-id")
            if (backgroundImageId) {
                AppContext.getApiClient().get('/images/' + backgroundImageId).then(i => {
                    this.setState({
                        backgroundImage: i,
                    })
                })
            } else {
                this.setState({
                    backgroundImage: null,
                })
            }
        })
    }

    getOptionValue(optionKey) {
        const search = this.state.options.filter(o => o.attributes.optionKey === optionKey)
        if (search.length) {
            return search[0].attributes.value
        }
        return ''
    }


    render() {
        if (this.state.options.length == 0) {
            return <div />
        }

        let backgroundStyle = {}
        let bannerStyle = {}
        if (this.state.backgroundImage) {
            const src = this.state.backgroundImage.attributes.publicUrlBySize['1280x800'] || this.state.backgroundImage.attributes.publicUrl
            backgroundStyle = {
                backgroundImage: `url(${src})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition:  'center',
            }
            bannerStyle = {
                border: 0,
            }
        } else {
            bannerStyle = {
                backgroundColor: this.getOptionValue('banner-color'),
                width: '100%',
                height: '40%',
                position: 'absolute',
                zIndex: 0,
                top: 0,
                left: 0,
            }
            backgroundStyle = {
                fontFamily: this.getOptionValue('font'),
                backgroundColor: this.getOptionValue('background-color')
            }
        }

        return (
            <div className={"row " + this.state.className} style={this.state.style}>
                <div className={"col-12 border py-1 bg-light"}>
                    <Icon value={"circle"} className={"text-danger mr-1"}/>
                    <Icon value={"circle"} className={"text-warning mr-1"}/>
                    <Icon value={"circle"} className={"text-success mr-2"}/>
                    {this.state.title ? this.state.title : <FormattedMessage
                        id="settings.proposal.preview.browser_label"
                        defaultMessage="Browser"
                    />}
                </div>
                <div className={"col-12"}>
                    <div className={"row justify-content-center border"} style={backgroundStyle}>
                        <div className={""} style={bannerStyle} ><br /></div>
                        <div className={"col-md-10"}>
                            <div className={"row ui-has-module"}>
                                <div className={"col-12 ui-module mt-5"}>
                                    <p className={"text-center"}>
                                        {this.state.companyLogo ?
                                            <Image image={this.state.companyLogo} size="very-small" /> :
                                            <strong>{this.state.companyName}</strong>}
                                    </p>
                                    <p className={"fake-text mb-0"} />
                                </div>
                                <div className={"col-12 ui-module px-0"}>
                                    <p className={"px-3"} style={{color: this.getOptionValue('secondary-color')}}>
                                        <strong>
                                            <FormattedMessage
                                                id="settings.proposal.preview.title_label"
                                                defaultMessage="Section title"
                                            />
                                        </strong>
                                    </p>
                                    <p className={"fake-text mx-3"} />
                                    <p className={"fake-text mx-3"} />
                                    {this.state.small ? '' : <p className={"mb-2 px-3 py-1 text-white"} style={{backgroundColor: this.getOptionValue('group-title-background-color')}}>
                                        <FormattedMessage
                                            id="settings.proposal.preview.groupe_name_label"
                                            defaultMessage="Group name"
                                        />
                                    </p>}
                                    {this.state.small ? '' : <p className={"mb-1 px-3"} style={{color: this.getOptionValue('primary-color')}}>
                                        <FormattedMessage
                                            id="settings.proposal.preview.product_name_label"
                                            defaultMessage="Product or service name"
                                        />
                                    </p>}
                                    {this.state.small ? '' : <p className={"fake-text mx-3"} />}
                                    <p className={"mb-2 px-3 py-1 text-white"} style={{backgroundColor: this.getOptionValue('group-title-background-color')}}>
                                        <FormattedMessage
                                            id="settings.proposal.preview.groupe_name_label"
                                            defaultMessage="Group name"
                                        />
                                    </p>
                                    <p className={"mb-1 px-3"} style={{color: this.getOptionValue('primary-color')}}>
                                        <FormattedMessage
                                            id="settings.proposal.preview.product_name_label"
                                            defaultMessage="Product or service name"
                                        />
                                    </p>
                                    <p className={"fake-text mb-0 mx-3"} />
                                </div>
                                <div className={"col-12 ui-module"}>
                                    <p className={"fake-text"} />
                                    <p className={"fake-text"} />
                                    <p className={"text-center mb-0"} style={{color: this.getOptionValue('primary-color')}}>
                                        <button onClick={e => {e.preventDefault()}} className={"btn btn-sm btn-primary px-5 pb-2"} style={{
                                            outlineColor: this.getOptionValue('button-color'),
                                            backgroundColor: this.getOptionValue('button-color'),
                                            borderColor: this.getOptionValue('button-color'),
                                        }}>
                                            <FormattedMessage
                                                id="settings.proposal.preview.button_label"
                                                defaultMessage="Button"
                                            />
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

}

export default ProposalColorPreview


// WEBPACK FOOTER //
// ./src/settings/proposals/colorPreview.component.jsx